import { COMPLAIN_COMPLAINTS_FETCHED, COMPLAIN_FAIL_REQUEST } from '../../constants/actionTypes/complain';
import { IComplain } from '../../types/complain';
import { TReduxActions } from '../../types/redux';

const defaultState = {
  manifest: null,
  isError: false,
};

export function complainReducer(state: IComplain = defaultState, action: TReduxActions) {
  switch (action.type) {
    case COMPLAIN_FAIL_REQUEST:
      return {
        ...state,
        isError: action.isError,
      };

    case COMPLAIN_COMPLAINTS_FETCHED: {
      const { manifest } = action;

      return {
        ...state,
        manifest,
      };
    }

    default:
      return state;
  }
}
